import { connect, MapDispatchToProps } from 'react-redux';
import { Props } from './SubscriptionsCoreOnlyBlock';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';

export type DispatchProps = Pick<Props, 'createTier'>;
export type OwnProps = Omit<Props, keyof DispatchProps>;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  createTier: () =>
    dispatch(
      pushModal(ModalType.TIER_EDIT, {
        wrapInModal: false,
      })
    ),
});

export default connect(null, mapDispatchToProps);
